import React from 'react';

import { EvTableColumn, EvTableOptions } from '@evinced-private/ui-common';

import { MobileSdkComponentDetailsBlock } from 'src/apps/mobile-sdk/components/MobileSdkComponentDetailsBlock';
import { IMobileSdkTestIssue } from 'src/apps/mobile-sdk/types/MobileSdkServiceTypes';
import { stringCellFormatter } from 'src/common/components/ev-table/cell-formatters/string-cell-formatter/stringCellFormatter';
import {
	IElementInfo,
	IssueElementInfoFormatter
} from 'src/common/components/issue-element-info-formatter/IssueElementInfoFormatter';
import { MobileScreenshotCellFormatter } from 'src/common/components/mobile-screenshot-cell-formatter/MobileScreenshotCellFormatter';
import { SeverityCellFormatter } from 'src/common/components/severity-cell-formatter/SeverityCellFormatter';
import { ShowIssueDetailsCellFormatter } from 'src/common/components/show-details-cell-formatter/ShowIssueDetailsCellFormatter';

export const MOBILE_SDK_ALL_ISSUES_TABLE_OPTIONS: EvTableOptions = {
	keyField: 'id',
	title: 'Mobile SDK Test Issues',
	caption: 'Mobile SDK Test Issues table',
	pagination: true,
	dataType: 'issues',
	remote: true
};

export const getMobileSdkAllIssuesColumns = (testId: string): EvTableColumn[] => [
	{
		dataField: 'type',
		text: 'Issue type',
		style: { width: '200px' },
		headerStyle: { width: '200px' },
		formatter: stringCellFormatter,
		sort: true
	},
	{
		dataField: 'severity',
		text: 'Severity',
		style: { width: '120px' },
		headerStyle: { width: '120px' },
		sort: true,
		formatter: (severity: string) => <SeverityCellFormatter severity={severity} />
	},
	{
		dataField: 'scanName',
		text: 'Scan',
		style: { width: '140px' },
		headerStyle: { width: '140px' },
		formatter: stringCellFormatter,
		sort: true
	},
	{
		dataField: 'elementInfo',
		text: 'Element description',
		style: { width: '400px' },
		headerStyle: { width: '400px' },
		formatter: (elementInfo: IElementInfo[], issue: IMobileSdkTestIssue) => (
			<IssueElementInfoFormatter
				elementInfo={elementInfo}
				nodeNumber={issue.shortNodeId}
				withTooltip={true}
			/>
		)
	},
	{
		dataField: 'screenshotUrl',
		text: 'Screenshot',
		style: { width: '182px', minWidth: '182px' },
		headerStyle: { width: '182px' },
		formatter: (cell, issue: IMobileSdkTestIssue) => (
			<MobileScreenshotCellFormatter
				cellDescriptor={issue.type}
				screenshotDetails={{
					pageScreenshotUrl: issue.screenshotUrl,
					boundingBoxes: [issue.boundingBox]
				}}
				viewportWidth={issue.viewportWidth}
				viewportHeight={issue.viewportHeight}
			/>
		)
	},
	{
		dataField: '',
		text: '',
		style: { width: '60px' },
		headerStyle: { width: '60px' },
		formatter: (cell, issue: IMobileSdkTestIssue) => {
			const renderDetailsBlock = (): JSX.Element => {
				return (
					<MobileSdkComponentDetailsBlock
						issueId={issue.id}
						testId={testId}
						scanName={issue.scanName}
						runTime={issue.runTime}
						issueNumber={issue.shortNodeId}
					/>
				);
			};

			return (
				<ShowIssueDetailsCellFormatter
					renderDetailsBlock={renderDetailsBlock}
					infoTitle="See Issue details"
					className="mobile-details-popup"
				/>
			);
		}
	}
];
